import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faMobile, IconDefinition } from '@fortawesome/pro-light-svg-icons';

import styles from './DeviceSwitch.module.scss';

type DeviceProps = {
  name: 'pc' | 'sp';
  icon: IconDefinition;
};

const devices: DeviceProps[] = [
  { name: 'pc', icon: faDesktop },
  { name: 'sp', icon: faMobile },
];

type Props = {
  activeDevice: string;
  setActiveDevice: (value: DeviceProps['name']) => void;
};

const DeviceSwitch: React.FC<Props> = ({ activeDevice, setActiveDevice }) => (
  <ul className={styles.devices}>
    {devices.map((device) => (
      <li key={device.name}>
        <button
          type='button'
          className={`${styles.button} ${activeDevice === device.name ? styles.active : ''}`}
          disabled={activeDevice === device.name}
          onClick={() => setActiveDevice(device.name)}
        >
          <FontAwesomeIcon icon={device.icon} className={styles.icon} />
        </button>
      </li>
    ))}
  </ul>
);

export default DeviceSwitch;
